export default __webpack_public_path__ + "dc01a3dfd47967949745f19886b59a3b.svg";